import React from "react"
import { Star, ChevronLeft, Search } from "react-feather"
import AddressInput from './AddressInput'

export default class SearchDestination extends React.PureComponent {
  render() {
    return (
      <React.Fragment>
        <div className="container">
          <div checkbox className="search-container" >
            <div checkbox className="field" >
              <div className="white">
                <div
                  className="icon back"
                  onClick={() => this.props.goBack()}
                >
                  <ChevronLeft />
                </div>
                <AddressInput
                  value={this.props.customDestinationAddress}
                  city ={this.props.city}
                  placeholder=' 查询目的地 '
                  changeAddress={(newValue, method) => this.props.changeAddress(newValue, method)}
                  changeCoords={(geoLocation, city) => this.props.changeCoords(geoLocation, city)}
                />
                { /* #TODO clear the field */ }
                <div className="icon search">
                  <Search />
                </div>
              </div>
            </div>
            <div className="search-recommendations">
              {
                this.props.categories.map(({ tag, label }) => (
                  <div
                    key={tag}
                    className="row"
                    onClick={() => {
                      this.props.push(`/catalogo/${this.props.city}/transportation?step=showRecomendation&selectRencButt=${tag}`)
                    }}
                  >
                    <div className="left"><Star /></div>
                    <div className="right">{label}</div>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/catalogo/transportation/components/SearchDestination.jsx